import React, {useState, useEffect, Fragment, useContext} from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import {Button} from 'react-bootstrap';
import FormSection from "../../../../components/sales/formSection/formSection";
import s from "../../../../components/sales/paymentPortal/addPayment/addPayment.module.css";
import DropDownInput from "../../../../components/sales/Input/dropDownInput/dropDownInput";
import ModalPop from "../../../../components/sales/modal/modal";
import {toast} from "react-toastify";
import Images from "../../../../assets/images/imageData";
import {Link} from "react-router-dom";
import {BaseUrl} from "../../../../contexts/baseUrl/baseUrl";
import localization from 'assets/localization/localization';

const headers = [
    'Ticket ID',
    'Site No',
    'Site Name',
    'Raised by',
    'Creation Date',
    'Internal Status',
    'Assigned Person',
    'Assignment Date',
    'Resolution Date',
    'Closed By',
    'Action'
];

const TechComplainList = ({
    centralTechComplainRaiseList,
    centralTechComplainRaiseListResponse = [],
    centralTechList,
    centralTechListResponse = [],
    changeCentralTech,
    getRmTicketsFilterDropDown,
    rmTicketFilter,
}) => {
    const [listData, setListData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [changeAssignModalOpen, setChangeAssignModalOpenForCentralTech] = useState(false);
    const [changeAssignId, setChangeAssigns] = useState('');
    const {baseUrl} = useContext(BaseUrl);
    const [compId, setComplainId] = useState('');
    const [roleId, setRoleId] = useState('');
    const [showFilter, setShowFilter] = useState(false);
    const [filterData, setFilterData] = useState(null);

    useEffect(() => {
        (async () => {
            let roleId = localStorage.getItem('fusion-role')
            setRoleId(roleId)
            setIsLoading(true);

            const getcontractFilter = await JSON.parse(
                localStorage.getItem("cteComplaintList") &&
                    localStorage.getItem("cteComplaintList")
            );
            if (getcontractFilter) {
                await centralTechComplainRaiseList(1, getcontractFilter);
            } else {
                await centralTechComplainRaiseList(1);
            }
            await centralTechList();
            await getRmTicketsFilterDropDown();
            setIsLoading(false);
        })();
    }, []);

    useEffect(() => {
        const tableData = [
            'id',
            'site_no',
            'client_name',
            'name',
            'created_at',
            'internal_status',
            'assignee_name',
            'assign_date',
            'closure_date',
            'closure_name'
        ];

        if (centralTechComplainRaiseListResponse && centralTechComplainRaiseListResponse?.data?.length > 0) {
            const data = centralTechComplainRaiseListResponse?.data?.map((element) =>
                Object.assign(
                    {},
                    ...tableData.map((key) => ({[key]: element[key]})),
                    (element['internal_status'] !== 'Closed' && parseInt(roleId) === 61) ?
                    {
                        Action: [
                            { name: 'View Complain', link: `/dashboard/central-tech-view-issue` },
                            { name: 'Assign', link: '' }
                        ],
                    } :
                    {
                        Action: [
                            { name: 'View Complain', link: `/dashboard/central-tech-view-issue` }
                        ]
                    }
                )
            );
            if (data && data?.length > 0) {
                setListData(data);
                setPageCount(Math.ceil(centralTechComplainRaiseListResponse?.total / centralTechComplainRaiseListResponse?.per_page));
                setCurrentPage(centralTechComplainRaiseListResponse?.current_page);
            }
        } else {
            setListData([]);
        }
    }, [centralTechComplainRaiseListResponse]);

    const onPageChange = async (val) => {
        let filter = filterData === null ? null : filterData;
        setIsLoading(true);
        await centralTechComplainRaiseList(val.selected + 1, filter);
        setIsLoading(false);
    };

    const applyFilter = async (filterValues) => {
        localStorage.setItem("cteComplaintList", JSON.stringify(filterValues));
        setIsLoading(true);
        setFilterData(filterValues);
        await centralTechComplainRaiseList(1, filterValues);
        setIsLoading(false);
        filterToggle();
    };

    const filterToggle = () => {
        setShowFilter(!showFilter);
    };

    const submitStatus = async () => {
        if (!changeAssignId) {
            toast.error('Please select Central Tech Engineer');
            return;
        }
        setIsLoading(true);
        const result = await changeCentralTech({ assignee_id: changeAssignId, complain_id: compId });
        if (result?.ok) {
            toast.success(result.message || 'Assignee updated successfully');
            setChangeAssignModalOpenForCentralTech(false);
            const savedFilter = JSON.parse(localStorage.getItem('cteComplaintList') || 'null');
            await centralTechComplainRaiseList(currentPage, savedFilter || filterData);
        }
        setIsLoading(false);
    };

    const headerBtns = () => (
        <Fragment>
            <Button
                onClick={filterToggle}
                className="filter-hamburger btn btn-transparent"
            >
                <img src={Images?.Filter} alt=""></img>
                {localization.showFilters}
            </Button>
            <Link
                to={`${baseUrl}/central-tech-complain`}
                className="btn btn-primary d-md-inline-block"
            >
                {"Raise Ticket"}
                <img src={Images?.ArrowRight} alt="" />
            </Link>
        </Fragment>
    );

    return (
        <Layout
            title={'Ticket List'}
            isLoading={isLoading}
            Buttons={headerBtns}
        >
            <TableSection
                data={listData}
                headers={headers}
                detailList={centralTechComplainRaiseListResponse?.data}
                pageCount={pageCount}
                srNo={centralTechComplainRaiseListResponse?.from}
                currentPage={currentPage}
                onPageChange={onPageChange}
                setCentralTechChangeAssigns={setComplainId}
                setChangeAssignModalOpenForCentralTech={setChangeAssignModalOpenForCentralTech}
            />

            <ListFilters
                showFilter={showFilter}
                filterToggle={filterToggle}
                applyFilter={(val) => applyFilter(val)}
                statusId=''
                listFilterData={rmTicketFilter?.sites ? rmTicketFilter : null}
                cteTicketFilter
                localstorageKey="cteComplaintList"
            />

            <ModalPop
                title={"Change Assignee"}
                show={changeAssignModalOpen}
                handleModalHide={() => { setChangeAssignModalOpenForCentralTech(false); }}
            >
                <Fragment>
                    <FormSection>
                        <div className={s.root}>
                            <div className={s.root}>
                                <div>
                                    <div className="col-sm-12 col-ms-12 ">
                                        <DropDownInput
                                            label={"Central Tech Engineer"}
                                            data={centralTechListResponse}
                                            value={""}
                                            isStarRequired={true}
                                            getIdValue={(val) => { setChangeAssigns(val.id); }}
                                            required={true}
                                        />
                                    </div>
                                    <br />
                                    <div className="confirm-button" style={{ marginBottom: "15px" }}>
                                        <div className="col-md-6 col-sm-6">
                                            <div className={s.button} style={{ width: "36%" }}>
                                                <Button onClick={() => submitStatus()}>
                                                    {"Final Submit"}
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </FormSection>
                </Fragment>
            </ModalPop>
        </Layout>
    );
};

export default TechComplainList;
